module.exports = __webpack_public_path__ + "static/media/pic1.5c66f3f1.jpg";